<template>
  <div class="ui small modal" ref="modal">
    <div class="ui inverted dimmer" v-bind:class="{ active: processing }">
      <div class="ui text double slow blue loader">{{ $t("loading") }}</div>
    </div>
    <i class="close icon"></i>
    <div class="icon header">
      <i class="calendar alternate icon"></i>
      {{ $t("event") }}
    </div>
    <div class="image content">
      <div class="ui small image">
        <img src="/images/icons/calendar.png" />
      </div>
      <div class="description">
        <div class="ui form" ref="form">
          <div class="fields">
            <div class="eight wide field">
              <label>{{ $t("start date") }}</label>
              <div class="ui calendar" ref="start_date">
                <div class="ui input left icon">
                  <i class="calendar icon"></i>
                  <input
                    type="text"
                    name="start_date"
                    :placeholder="$t('start date')"
                  />
                </div>
              </div>
            </div>
            <div class="eight wide field">
              <label>{{ $t("end date") }}</label>
              <div class="ui calendar" ref="end_date">
                <div class="ui input left icon">
                  <i class="calendar icon"></i>
                  <input
                    type="text"
                    name="end_date"
                    :placeholder="$t('end date')"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="fields">
            <div class="thirteen wide field">
              <label for>{{ $t("title") }}</label>
              <input type="text" name="title" v-model="event_.title" />
            </div>
            <div class="three wide field">
              <label for>{{ $t("color") }}</label>
              <swatches
                colors="material-basic"
                shapes="circles"
                v-model="event_.color"
              />
            </div>
          </div>
          <div class="field">
            <label for="">{{ $t("description") }}</label>
            <textarea
              name="description"
              rows="2"
              v-model="event_.description"
            ></textarea>
          </div>
          <div class="three fields"></div>
          <div class="ui error message"></div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div
        class="ui left floated red icon right labeled button"
        @click="remove"
        v-show="event_.event_id"
      >
        <i class="trash icon"></i>
        {{ $t("remove") }}
      </div>
      <div class="ui red icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("cancel") }}
      </div>
      <div class="ui green right labeled icon button" v-on:click="finish">
        {{ $t("ok") }}
        <i class="checkmark icon"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import moment from "moment";
// import alertify from "alertifyjs";
import Swatches from "vue-swatches";
// import "vue-swatches/dist/vue-swatches.min.css";

export default {
  data() {
    return {
      processing: false,
      event_: {
        event_id: "",
        title: "",
        description: "",
        color: "#009CE0",
      },
    };
  },
  components: {
    Swatches,
  },
  props: {
    event: Object,
  },
  mounted() {
    // let vm = this;
    // if ("event_id" in this.$props.event) {
    //   this.event_ = {
    //     title: this.$props.event.setup.title,
    //     description: this.$props.event.setup.description,
    //     color: this.$props.event.setup.color,
    //   };
    // }
    // window
    //   .jQuery(vm.$el)
    //   .modal({
    //     onShow() {
    //       window.jQuery(vm.$refs.form).form({
    //         fields: {
    //           title: ["empty"],
    //           start_date: ["empty"],
    //           end_date: ["empty"],
    //         },
    //         onSuccess(event, fields) {
    //           fields.color = vm.event_.color;
    //           fields.event_id = vm.$props.event.event_id;
    //           local_api(vm, "post", "/calendar/do-save-event", fields)
    //             .then((response) => {
    //               vm.$emit("succedded", response);
    //               window.jQuery(vm.$el).modal("hide");
    //             })
    //             .catch((err) => {
    //               window.jQuery(vm.$refs.form).form("add errors", [err]);
    //             });
    //         },
    //       });
    //       // if ("start_at" in vm.$props.event) {
    //       //   window
    //       //     .jQuery(vm.$refs.start_date)
    //       //     .calendar("set date", vm.$props.event.start_at);
    //       // }
    //       // if ("end_at" in vm.$props.event) {
    //       //   window
    //       //     .jQuery(vm.$refs.end_date)
    //       //     .calendar("set date", vm.$props.event.end_at);
    //       // }
    //     },
    //     onVisible() {},
    //     onHidden() {
    //       vm.$destroy();
    //     },
    //   })
    //   .modal("show");
    // window.jQuery(vm.$refs.start_date).calendar({
    //   type: "datetime",
    //   endCalendar: window.jQuery(vm.$refs.end_date),
    //   today: true,
    // });
    // window.jQuery(vm.$refs.end_date).calendar({
    //   type: "datetime",
    //   startCalendar: window.jQuery(vm.$refs.start_date),
    //   today: true,
    // });
  },
  methods: {
    finish() {
      window.jQuery(this.$refs.form).form("validate form");
    },
    show_modal(options) {
      let vm = this;
      // if (options) {
      //   console.log("options", options);
      // }
      // console.log(options);
      window
        .jQuery(vm.$refs.modal)
        .modal({
          onHide() {
            // console.log(vm.$refs);
            window.jQuery(vm.$refs.form).form("clear");

            vm.event_.event_id = "";
          },
          onShow() {
            if (options) {
              // console.log("options: ", options);
              if (options.type == "date_click") {
                let start_date = options.info.date;
                let end_date = moment(options.info.date)
                  .add(30, "minutes")
                  .toDate();
                // console.log("end_date", end_date);
                window
                  .jQuery(vm.$refs.start_date)
                  .calendar("set date", start_date);
                window.jQuery(vm.$refs.end_date).calendar("set date", end_date);
              } else if (options.type == "event_click") {
                window
                  .jQuery(vm.$refs.start_date)
                  .calendar("set date", options.info.start_at);
                window
                  .jQuery(vm.$refs.end_date)
                  .calendar("set date", options.info.end_at);

                if (options.info && options.info.setup && options.info.event_id)
                  vm.event_.event_id = options.info.event_id;
                if (
                  options.info &&
                  options.info.setup &&
                  options.info.setup.title
                )
                  vm.event_.title = options.info.setup.title;
                if (
                  options.info &&
                  options.info.setup &&
                  options.info.setup.description
                )
                  vm.event_.description = options.info.setup.description;
                if (
                  options.info &&
                  options.info.setup &&
                  options.info.setup.color
                )
                  vm.event_.color = options.info.setup.color;
              }
            }

            window.jQuery(vm.$refs.form).form({
              fields: {
                title: ["empty"],
                start_date: ["empty"],
                end_date: ["empty"],
              },
              onSuccess(event, fields) {
                fields.color = vm.event_.color;
                fields.event_id = vm.event_.event_id;
                local_api(vm, "post", "/calendar/do-save-event", fields)
                  .then((response) => {
                    vm.$emit("succedded", response);
                    window.jQuery(vm.$el).modal("hide");
                  })
                  .catch((err) => {
                    window.jQuery(vm.$refs.form).form("add errors", [err]);
                  });
              },
            });

            window.jQuery(vm.$refs.start_date).calendar({
              endCalendar: window.jQuery(vm.$refs.end_date),
              today: true,
            });

            window.jQuery(vm.$refs.end_date).calendar({
              startCalendar: window.jQuery(vm.$refs.start_date),
              today: true,
            });
          },
        })
        .modal("show");
    },
    remove() {
      let vm = this;
      vm.$alertify.confirm(vm.$t("are you sure to remove event?"), function () {
        local_api(vm, "post", "/calendar/do-remove-event", {
          u: vm.event_.event_id,
        })
          .then(() => {
            vm.$emit("deleted");
            window.jQuery(vm.$refs.modal).modal("hide");
          })
          .catch((err) => {
            error_toast(err);
          });
      });
    },
  },
  watch: {},
};
</script>

<style scoped>
.content .description {
  width: 100% !important;
}
</style>
